import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-reading-boys',
    templateUrl: './page-reading-boys.component.html',
    styleUrls: ['./page-reading-boys.component.css'],
    standalone: false
})
export class PageReadingBoysComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
